export enum ProjectsQueries {
  Project = 'project',
  ProjectInfo = 'projectInfo',
  SearchProject = 'searchProject',
}
